import React from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

const AdminDashboard = () => {
  const handleSync = async () => {
    const session = await supabase.auth.getSession();
    const token = session?.data?.session?.access_token;

    const res = await fetch('/api/sync-registrations', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ requesterToken: token }),
    });

    const result = await res.json();
    alert(result.message || 'Sync complete');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h1 className="text-3xl font-bold mb-6 text-center">Admin Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

        {/* User Management */}
        <div className="bg-white rounded-2xl shadow p-6">
          <h2 className="text-xl font-semibold mb-2">👤 User Management</h2>
          <ul className="text-sm space-y-1">
            <li><Link to="/admin/users" className="text-blue-600 hover:underline">View All Users</Link></li>
            <li><Link to="/admin/roles" className="text-blue-600 hover:underline">Manage Roles</Link></li>
            <li>
              {false && (
  <button
    onClick={handleSync}
    className="mt-2 inline-block text-sm bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1 rounded"
  >
    🔄 Sync Registrations
  </button>
)}

            </li>
          </ul>
        </div>

        {/* Course Management */}
        <div className="bg-white rounded-2xl shadow p-6">
          <h2 className="text-xl font-semibold mb-2">📚 Course Management</h2>
          <ul className="text-sm space-y-1">
            <li><Link to="/admin/courses" className="text-blue-600 hover:underline">View/Edit Courses</Link></li>
            <li><Link to="/admin/courses/new" className="text-blue-600 hover:underline">Create New Course</Link></li>
          </ul>
        </div>

        {/* Analytics */}
        <div className="bg-white rounded-2xl shadow p-6">
          <h2 className="text-xl font-semibold mb-2">📊 Analytics</h2>
          <ul className="text-sm space-y-1">
            <li><Link to="/admin/analytics/usage" className="text-blue-600 hover:underline">Site Usage</Link></li>
            <li><Link to="/admin/analytics/progress" className="text-blue-600 hover:underline">Student Progress</Link></li>
          </ul>
        </div>

       {/* Feedback */}
<div className="bg-white rounded-2xl shadow p-6">
  <h2 className="text-xl font-semibold mb-2">📝 Feedback & Messages</h2>
  <ul className="text-sm space-y-1">
    <li><Link to="/admin/feedback" className="text-blue-600 hover:underline">View Feedback</Link></li>
    <li><Link to="/admin/inbox" className="text-blue-600 hover:underline">📥 View Inbox</Link></li>
  </ul>
</div>


        {/* Announcements */}
        <div className="bg-white rounded-2xl shadow p-6">
          <h2 className="text-xl font-semibold mb-2">📢 Announcements</h2>
          <ul className="text-sm space-y-1">
            <li><Link to="/admin/announcements" className="text-blue-600 hover:underline">Create Announcement</Link></li>
          </ul>
        </div>

        {/* Content Moderation */}
        <div className="bg-white rounded-2xl shadow p-6">
          <h2 className="text-xl font-semibold mb-2">🔒 Content Moderation</h2>
          <ul className="text-sm space-y-1">
            <li><Link to="/admin/moderation" className="text-blue-600 hover:underline">Moderate Discussions</Link></li>
          </ul>
        </div>

      </div>
    </div>
  );
};

export default AdminDashboard;
